export default (settings, module_name) => {
  const productsContainer = document.querySelector('[data-content-container]');
  const products = productsContainer.innerHTML;
  const html = `
    <div class="Module-${module_name}__Content">
      <div class="Module-${module_name}__Products" data-cms-product-slider>
        <div class="ScrollCarousel__viewport" data-cms-product-slider-viewport>
          <div class="ScrollCarousel__track" data-cms-product-slider-track>
            ${products}
          </div>
        </div>
      </div>
    </div>
  `;
  return html;
};
